import { ClientType, FactoryFunction, IClientFactory } from "@multiweb/clients/index";
import { DIContainer } from "Global/Base/DIContainer";

const REGISTER_SINGLETONS = true;
const REGISTRATION_PREFIX = "API#";

/**
 * Pro uchovávání implementací klientů používá standardní _DIContainer_.
 * Jako klíče jsou používané řetězce z enumu _ClientType_ a pro jistotu prefixované _REGISTRATION_PREFIX_.
 * Implementace jsou singletony (vždy je vrácena stejná instance).
 */
export class ClientFactory implements IClientFactory {
    private _container = DIContainer.instance;

    public register(clientType: ClientType | string, factory: FactoryFunction): void {
        this._container.registerFactory(this._createIdentifier(clientType), factory, REGISTER_SINGLETONS);
    }

    public get(clientType: ClientType | string): unknown {
        return this._container.create(this._createIdentifier(clientType));
    }

    private _createIdentifier(clientType: ClientType | string): string {
        return `${REGISTRATION_PREFIX}${clientType}`;
    }
}
